export class ProviderDetailRequest {
  public secureAuthUserName: string;
  public providerId: number;
  public prpId: string;
  public pradtype: string;
}
